import {
    LinkStatus,
    LinkStatusMap
} from '@common';
import { Tag } from 'antd';
import cs from 'classnames';
import Styles from './Styles.module.scss';
import { useCurrentApp } from './hooks';

export default function Tags() {
    const { app } = useCurrentApp();

    const color = app?.accessManagement.access === 'public' ? 'green' : 'purple';

    return (
        <div className={Styles.StatusContainer}>
            <div
                className={cs(
                    Styles.Status,
                    { [Styles.Online]: app?.linkStatus === LinkStatus.ONLINE },
                    { [Styles.Offline]: app?.linkStatus === LinkStatus.OFFLINE },
                    { [Styles.Error]: app?.linkStatus === LinkStatus.ERROR }
                )}
            >
                {app ? LinkStatusMap[app.linkStatus] : ''}
            </div>
            <Tag
                className={Styles.ModelTag}
                color={color}
                key={app?.accessManagement.access}
            >
                {app?.accessManagement?.access.toUpperCase()}
            </Tag>
        </div>
    );
}
